const productEnum = {
  CAMERA: 'camera',
  TABLEWARE: 'tableware',
};

export default productEnum;
